var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5ZM3 8.5C3 11.2614 5.23858 13.5 8 13.5C10.7614 13.5 13 11.2614 13 8.5C13 5.73858 10.7614 3.5 8 3.5C5.23858 3.5 3 5.73858 3 8.5Z",
    fill: "#F67D88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75005 6.5C9.16427 6.5 9.50005 6.16421 9.50005 5.75C9.50005 5.33579 9.16427 5 8.75005 5C8.33584 5 8.00005 5.33579 8.00005 5.75C8.00005 6.16421 8.33584 6.5 8.75005 6.5Z",
    fill: "#F5D0D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5002 12.5C7.18033 12.5 6.94272 12.2038 7.01211 11.8915L7.88012 7.98549C7.66198 7.93171 7.5002 7.73475 7.5002 7.5C7.5002 7.22386 7.72406 7 8.0002 7H8.5002C8.82008 7 9.05769 7.29621 8.98829 7.60847L8.12028 11.5145C8.33843 11.5683 8.5002 11.7653 8.5002 12C8.5002 12.2761 8.27634 12.5 8.0002 12.5H7.5002Z",
    fill: "#F5D0D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.09cbc05708954715f6c2287e70937c8e.svg";
export { ForwardRef as ReactComponent };